import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_apex_web_flextras_as_ancillaries_v4_ddot",
    stages: {
        affected: 1,
        main: 2,
        flex_only: 3,
        flex_and_cfar: 4,
        flex_rec_medium_plus: 5,
        cfar_rec_medium_plus: 6,
        flex_rec_low: 7,
        cfar_rec_low: 8,
        cfar_cta_visible_without_scroll: 9
    },
    goals: {
        action_click_no_flexibility: 1,
        click_price_info: 2,
        modal_continue_with_flex: 3,
        modal_continue_without_flex: 4
    },
    defaultStage: 1
});
const trackStages = ({ hasFlex, hasCfar, flexRecommendation, cfarRecommendation }) => {
    utils.stages.main();
    if (hasFlex && !hasCfar)
        utils.stages.flex_only();
    if (hasCfar && hasFlex)
        utils.stages.flex_and_cfar();
    switch (flexRecommendation?.confidence) {
        case "MEDIUM":
        case "HIGH":
        case "VERY_HIGH":
            utils.stages.flex_rec_medium_plus();
            break;
        case "LOW":
            utils.stages.flex_rec_low();
            break;
        default:
            break;
    }
    switch (cfarRecommendation?.confidence) {
        case "MEDIUM":
        case "HIGH":
        case "VERY_HIGH":
            utils.stages.cfar_rec_medium_plus();
            break;
        case "LOW":
            utils.stages.cfar_rec_low();
            break;
        default:
            break;
    }
};
export default { ...utils, trackStages };
